export default "__VITE_ASSET__D558MEjN__"